import { render, staticRenderFns } from "./FlashProduct.vue?vue&type=template&id=24ac8261&scoped=true&"
import script from "./FlashProduct.vue?vue&type=script&lang=js&"
export * from "./FlashProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac8261",
  null
  
)

export default component.exports